<template>
  <div class="home" @click="reloadCode" >
    <h4 class="user-name" v-if="displayName">Hello, {{displayName}} <q-btn v-if="loggedAnonymous" flat to="/user/signup" icon="mdi-square-edit-outline" /></h4>
    <div class="q-pa-md row q-gutter-md justify-center" v-if="loading"><Spinner/></div>
    <div v-else>
      <QrCodeCustomer :key="key" :qrValue="qrValue" :userId="userId" :logged="logged" 
      :callback="updatePoints" @anonimous-signin="anonymousSign" />
      <perks-list class="perks-list" :perks="perks" :home="true" v-if="perks.length > 0"  />
      <div class="text-subtitle1 q-ma-sm" v-if="(logged || loggedAnonymous) && perks.length === 0">
        Show your code at the register to receive your first point.

        <q-btn class="full-width square q-ma-sm" v-if="!loggedAnonymous" label="How it works" to="/how-it-works" color="secondary" size="md" />
      </div>
      <q-btn flat color="primary" v-if="(logged || loggedAnonymous) && perks && perks.length > 0" class="q-ma-xs" label="Full History" to="/full-history" />
    </div>
    <!-- <banner-add-home :show="!addHome" @added-home="addedHome" /> -->
    <banner-privacy :privacy="!privacyBanner" @accept-privacy="acceptPrivacy" />
  </div>
</template>

<script>
// @ is an alias to /src

import QrCodeCustomer from "@/components/QrCodeCustomer";
import BannerPrivacy from "@/components/BannerPrivacy";
import BannerAddHome from "@/components/BannerAddHome";
import PerksList from "@/components/PerksList";
import VueCookies from "vue-cookies";
import Spinner from "@/components/Spinner";
import {ref, inject, onUnmounted, onMounted, nextTick} from "vue";
import { useStore } from 'vuex';
import { useQuasar } from 'quasar';

export default {
  name: 'Home',
  components: {QrCodeCustomer, PerksList, Spinner, BannerPrivacy, BannerAddHome},
  setup(){
    const loading = ref(true)
    const anonymousGuid = ref(VueCookies.get('anonymousGuid'))
    const qrValue = ref(null)
    const displayName = ref('')
    const logged = ref(false)
    const loggedAnonymous = ref(false)
    const key = ref(0) // force the qr code component to re-render after auth events, is a way to keep the qrcode component always updated
    const perks = ref([])
    const pointsT = ref([])
    const userId = ref(0)
    const axios = inject('axios')
    const store = useStore()
    const privacyBanner = ref(VueCookies.get('privacy'))
    const addHome = ref(VueCookies.get('addHome'))
    const $q = useQuasar()

    /*if (qv) {
      // qrValue.value = qv
    }*/

    onUnmounted(() => {
      window.removeEventListener('scroll', reloadCode);
    })

    onMounted(() => {
      window.addEventListener('scroll', reloadCode)
    })

    const getPoints = () => { // get the user points
      axios.get(`${process.env.VUE_APP_URL}/cards?page=1&itemsPerPage=3&owner=${userId.value}&order%5BupdatedAt%5D=desc`)
        .then(resp => {
          pointsT.value = resp.data
          perks.value = pointsT.value.map(point => {
            return {
              id: point.id,
              place: point.place,
              ownerId: point.ownerId,
              name: point.place.name,
              logo: point.place.logo,
              perks: point.place.perks,
              points: point.points,
              message: point.place.message,
              updatedAt: point.updatedAtAgo
            }
          })
        })
        .catch(err => {
          $q.notify({
            message: 'An error has ocurred!',
            caption: err.message,
            color: 'negative'
          })
          // error.value = 'An error ocurred when getting points. Wait a few moments and try again.'
        })
        .finally(() => loading.value = false)
    }

    const anonymousSign = (user) => {
      loggedAnonymous.value = true
      // userId.value = user
      // VueCookies.set('user', user)
      displayName.value = 'Anonymous'
      userId.value = user
      if (!qrValue.value) {
        qrValue.value = store.getters.stateUser.qrcode + '|' + displayName.value
        key.value = 4
      }
      store.commit('setAnonymous', true)
      getPoints()
    }

    const updatePoints = (perk) => {
      getPoints()
    }

    store.dispatch('verifyLogged')
    .then(async resp => {
      store.commit('setUser', resp.data)
      await nextTick()
      displayName.value = resp.data.name
      logged.value = true
      userId.value = resp.data.id
      if (resp.data.anonymousGuid && !resp.data.email) {
        logged.value = false
        anonymousSign(resp.data.id)
        anonymousGuid.value = resp.data.anonymousGuid
      }
      qrValue.value = resp.data.qrcode + '|' + displayName.value
      loading.value = false
      key.value = 1
      getPoints()
    })
    .catch(async error => {
      if (anonymousGuid.value) {
        let response = await store.dispatch('anonymousLogin', anonymousGuid.value)
        console.log(response.data)
        store.commit( 'setUser', response.data )
        anonymousSign(response.data.id)
      } else {
        store.commit('setUser', null)
        logged.value = false
        key.value = 2
        loading.value = false
      }
    })

    const reloadCode = () => {
      if(!store.getters.stateConnected && userId.value) key.value = 3
    }

    const acceptPrivacy = () => {
      VueCookies.set('privacy', true, Infinity)
      privacyBanner.value = true
    }

    const addedHome = (added) => {
      if (added) VueCookies.set('addHome', true, Infinity)
      addHome.value = true
    }

    addHome
    
    return {qrValue, displayName, perks, logged, loading, userId, pointsT, key, updatePoints, anonymousSign, 
    loggedAnonymous, reloadCode, privacyBanner, acceptPrivacy, addHome, addedHome }
  },
}
</script>

<style scoped>
@media only screen and (orientation:landscape) and (hover: none) and (pointer: coarse) {
  .perks-list, .user-name { display:none; }
  .scanner {
    max-width: 350px;
    margin: 0 auto;
  }
}
 
/* Show place card when portrait */
@media only screen and (orientation:portrait) and (hover: none) and (pointer: coarse) {
  .scan-header { display:block; }
}

.user-name {
  margin: 20px 0;
}
</style>